import React from 'react';
import { ValuesSection, ValuesList, ValueItem } from './Values.styles';
// import { SectionHeader } from '../About.styles';

const Values = () => {
  return (
    <ValuesSection>
      <div className="valuesTop">
        <span className="miniLabel">Our Core Values</span>

        <p>
          Our approach has always remained focused on dependable service,
          practical safety solutions, and long-term client relationships.
        </p>
      </div>

      <ValuesList>
        <ValueItem>Customer Service</ValueItem>
        <ValueItem>Quality</ValueItem>
        <ValueItem>Dependability</ValueItem>
        <ValueItem>Fair Pricing</ValueItem>
        <ValueItem>Practical Solutions</ValueItem>
      </ValuesList>
    </ValuesSection>
  );
};

export default Values;
